module.exports = __webpack_public_path__ + "static/media/a.485c2924.jpg";